import { commonServerInstance } from '@/utilities/instances'

export interface ICommonZoneList {
  page: string
  per_page: string
  statuses: string
  type: string
  common_zone_id: string
}

// for list-search
export const fetchCommonZoneList = async (params: ICommonZoneList) => {
  const response = await commonServerInstance.post(
    '/api/v1/rate-card/common-zone/search',
    params
  )
  return response?.data?.data
}

// for search filter list
export const fetchAllCommonZoneList = async (): Promise<
  Array<{ id: number; description: string }>
> => {
  const response = await commonServerInstance.get(
    '/api/v1/rate-card/common-zone/list-all'
  )
  return response?.data?.data
}

export const fetchCommonZoneTypeList = async (): Promise<
  Array<{ type: number; type_desc: string }>
> => {
  const response = await commonServerInstance.get(
    '/api/v1/rate-card/common-zone/types'
  )
  return response?.data?.data
}
